import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {isLoggedIn, loadUser} from 'services/auth';
import {handleError} from 'util/errors';
import RouteURLs from 'RouteURLs';
import NextRouteURLs from 'NextRouteURLs';
import {RouteComponentProps, withRouter} from "react-router";
import {AuthenticatedUser, UserGroup} from "services/entities/auth";

interface AuthenticationCheckRouteProps extends RouteComponentProps {
  component?: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
}

interface AuthenticationCheckRouteState {
  user?: AuthenticatedUser|null|undefined;
}

class AuthenticationCheckRouteBase<P extends AuthenticationCheckRouteProps = AuthenticationCheckRouteProps> extends Component<P, AuthenticationCheckRouteState> {
  state: AuthenticationCheckRouteState = {
    user: undefined
  };

  componentDidMount() {
    if(isLoggedIn()) {
      loadUser().then(
        user => this.setState({user: user}),
        ex => {
          handleError('Unable to load authentication', ex);
          this.setState({user: null})
        }
      );
    } else {
      this.setState({user: null});
    }
  }

  render() {
    if(this.props.component) {
      return React.createElement(this.props.component, this.props);
    } else {
      return null;
    }
  }
}

interface AuthenticatedRouteProps extends AuthenticationCheckRouteProps {
  requiredGroup?: UserGroup;
}

class AuthenticatedRouteBase extends AuthenticationCheckRouteBase<AuthenticatedRouteProps> {
  render() {
    const user = this.state.user;
    if(user === undefined) {
      return null;
    } else if(user === null) {
      return <Redirect to={RouteURLs.LOGIN} />;
    } else if(this.props.requiredGroup && user.groups.indexOf(this.props.requiredGroup) < 0) {
      return <Redirect to={NextRouteURLs.HOME}/>;
    } else {
      return super.render();
    }
  }
}

export const AuthenticatedRoute = withRouter(AuthenticatedRouteBase);


class UnauthenticatedRouteBase extends AuthenticationCheckRouteBase {
  render() {
    const user = this.state.user;
    if(user === undefined) {
      return null;
    } else if(user === null) {
      return super.render();
    } else {
      return <Redirect to={NextRouteURLs.HOME} />;
    }
  }
}

export const UnauthenticatedRoute = withRouter(UnauthenticatedRouteBase);